<template>
  <base-overlay :show="tripInfoLoading.details">
    <template v-if="!tripInfoLoading.details">
      <div class="d-flex justify-content-between align-items-center">
        <b-button
          class="btn-icon rounded-circle ml-1"
          variant="flat-primary"
          @click="fetchTripData"
        >
          <feather-icon
            icon="RefreshCwIcon"
          />
        </b-button>

        <div
          style="margin-bottom:-80px;z-index: 10;"
        >

          <b-badge
            v-if="isScheduledRide"
            variant="danger"
            class="mr-1"
            style="cursor:pointer"
            @click="openBookingDetails"
          >
            <span class="mr-1">Scheduled Trip</span>
            <feather-icon
              icon="EyeIcon"
            />
          </b-badge>

          <b-badge
            v-if="tripDetails.metadata.service.class"
            variant="primary"
            class="mr-1"
          >
            {{ snakeCaseToCamelCase(tripDetails.metadata.service.class) }}
          </b-badge>
          <b-badge
            v-if="tripDetails.metadata.tracking"
            variant="success"
          >
            Tracking
          </b-badge>

        </div>
      </div>

      <b-tabs v-model="tabsIndex">
        <b-tab title="General">
          <user-driver-details />

          <cancel-section v-if="tripDetails.state == 'CANCELED'" />

          <TripNote
            v-if="tripDetails.metadata.note && tripDetails.metadata.note.text"
            :note="tripDetails.metadata.note.text"
          />

          <trip-location />

          <b-card>
            <h3>Trip Timeline</h3>
            <trip-timeline />
          </b-card>

          <trip-actions
            v-if="tripTriggers.length && (tripDetails.state != 'COMPLETED' || tripDetails.state != 'CANCELED')"
            :trip-triggers="tripTriggers"
          />

        </b-tab>
        <b-tab title="Distance & Time">
          <b-row>
            <b-col md="4">
              <trip-request />
            </b-col>
            <b-col md="4">
              <trip-eta />
            </b-col>
            <b-col md="4">
              <base-overlay :show="tripInfoLoading.bill">
                <upfront-estimates
                  v-if="tripDetails.state == 'COMPLETED' && tripBillDetails"
                  :trip-bill-details="tripBillDetails"
                />
              </base-overlay>
            </b-col>
          </b-row>

        </b-tab>
        <b-tab title="Dispatch">
          <ChangeDriver v-if="tripDetails.state == 'ACCEPTED'" />
          <dispatch-history
            :dispatches="tripDetails.dispatches"
          />

        </b-tab>
        <b-tab
          v-if="tripDetails.state == 'COMPLETED'"
          title="Billing"
        >
          <trip-bill
            :trip-bill-details="tripBillDetails"
            @refetch-data="fetchTripData"
          />

        </b-tab>
        <b-tab
          title="Rating"
        >
          <trip-rating />
        </b-tab>
        <GroupSessionsTab />
        <GameTab />
      </b-tabs>
      <base-overlay :show="tripInfoLoading.path">
        <trip-path
          v-if="!tripInfoLoading.path"
          :trip-path="tripPath"
          :driver-location="driverLocation"
          @refetch-path="getTripPath"
        />
      </base-overlay>

    </template>

  </base-overlay>
</template>

<script>
import {
  BButton, BBadge, BTabs, BTab, BCard, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import tripsStore from '../store'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import useTripDetails from '../hooks/useTripDetails'
import UserDriverDetails from '../components/trip-details/quick-info/index.vue'
import driverStore from '@/views/driver/driverStoreModule'
import userStore from '@/views/users/rider/store'
import tripTimeline from '../components/trip-details/TripTimeline.vue'
import tripLocation from '../components/trip-details/location/index.vue'
import tripBill from '../components/trip-details/TripBill.vue'
import UpfrontEstimates from '../components/trip-details/UpfrontEstimates.vue'
import tripEta from '../components/trip-details/TripETA.vue'
import tripRequest from '../components/trip-details/TripRequests.vue'
import TripActions from '../components/trip-details/actions/TripActions.vue'
import TripPath from '../components/trip-details/TripPath.vue'
import CancelSection from '../components/trip-details/CancelSection.vue'
import DispatchHistory from '../components/trip-details/dispatch/DispatchHistory.vue'
import TripNote from '../components/trip-details/TripNote.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import ChangeDriver from '../components/trip-details/dispatch/change-driver.vue'
import GroupSessionsTab from '../components/trip-details/group-sessions/GroupSessionsTab.vue'
import GameTab from '../components/trip-details/game/GameTab.vue'
import TripRating from '../components/trip-details/TripRating.vue'

export default {
  components: {
    BRow,
    BCol,
    TripNote,
    BButton,
    GroupSessionsTab,
    GameTab,
    CancelSection,
    BCard,
    BTabs,
    BTab,
    UserDriverDetails,
    tripTimeline,
    ChangeDriver,
    tripLocation,
    tripBill,
    tripEta,
    tripRequest,
    BBadge,
    TripActions,
    TripPath,
    DispatchHistory,
    UpfrontEstimates,
    TripRating,
  },
  setup(_, ctx) {
    useRegisterStoreModule('trips', tripsStore)
    useRegisterStoreModule('drivers', driverStore)
    useRegisterStoreModule('users', userStore)

    const tabsIndex = ref(0)

    return {
      tabsIndex,
      snakeCaseToCamelCase,
      ...useTripDetails(ctx),
    }
  },
}
</script>

<style scoped>
table {
  width:100%
}
table td,
table th {
  padding: 5px;
  font-size: 16px;
}
table td {
  font-weight: normal;
}
table th {
  font-size: 15px;
}
tbody tr:hover{
  background-color: #d7e0f0;
  transition: all 0.3s;
}
</style>
